import React from 'react'

import { IconCheckSmall } from '@vtex/shoreline'

import { Container } from './styles'

/**
 *
 * Componente agnostico isolado
 */
const InputCheckbox = ({
  defaultChecked = false,
  inputRef,
  value,
  name,
  id,
  fieldName,
  label,
  error,
  className,
  disabled,
  isOptional = false,
  ...rest
}) => {
  return (
    <Container isDisabled={disabled}>
      <input
        ref={inputRef}
        value={value}
        name={name}
        type="checkbox"
        id={id}
        disabled={disabled}
        {...(defaultChecked ? { defaultChecked } : {})}
        {...rest}
      />

      <label htmlFor={id} key={fieldName} className={className}>
        <span className="checkbox-icon">
          <IconCheckSmall className="icon-check" aria-hidden="true" />
        </span>
        {label}
      </label>

      {error && <span>{error}</span>}
    </Container>
  )
}

export default InputCheckbox
